var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "loading" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-svg-container" }, [
      _c("div", { staticClass: "loading-svg" }),
      _c("span", { staticClass: "tip" }, [_vm._v("数据加载中")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }